import { useFormState, useFormContext, useWatch } from "react-hook-form";
import { useFormCoverage } from "./contexts.js";
import { allowedCauseIds } from "./costEditorScopes.js";

export const CLAIM_CAUSE_FIELD = "schaden_ursache";

/**
 * Restricts the options of the cause select to the causes the claim may name.
 * The value the claim was loaded with and the current one stay in the list, so
 * a stored cause outside the allowed list remains shown and selectable.
 * Other fields keep their options.
 */
export function useClaimCauseOptions(item, options) {
  const { control } = useFormContext();
  const coverage = useFormCoverage();
  const { defaultValues } = useFormState({ control });
  const [sparteId, current] = useWatch({
    control,
    name: ["sparte_id", CLAIM_CAUSE_FIELD],
  });

  if (item.name !== CLAIM_CAUSE_FIELD) {
    return options;
  }

  const allowed = allowedCauseIds({
    enabled: coverage.enabled,
    coverageTypes: coverage.coverageTypes,
    objektSparten: coverage.objektSparten,
    sparteId,
  });

  if (!allowed) {
    return options;
  }

  const kept = [current, defaultValues?.[CLAIM_CAUSE_FIELD]]
    .filter((value) => value != null && value !== "")
    .map(String);

  return options.filter(
    (option) =>
      allowed.includes(option.cause_id) || kept.includes(String(option.key))
  );
}
